import {Navigate, useLocation} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import {userRoute} from "pages/user/user.routes";
import {GUEST_BOOKING_ENABLED} from "conts/features";

// Quick booking lets visitors pick dates and check out before signing in.
const allowedRoutes = [
    userRoute.classDetail,
    userRoute.map,
    userRoute.searchOnline,
    ...(GUEST_BOOKING_ENABLED ? [userRoute.showMoreDates, userRoute.paymentPage] : []),
];

export const ProtectedRoute = ({children}) => {
    const {pathname} = useLocation();
    const {token} = useAuth();

    if (token) {
        return children;
    }

    const isAllowed = allowedRoutes.some(route => pathname.startsWith(route));

    if (isAllowed) {
        return children;
    }

    return <Navigate to="/"/>;
};
